export interface FaqItem {
  q: string;
  a: string;
}

export const FAQS: FaqItem[] = [
  {
    q: "幕外到底是什么类型的网站？",
    a: "幕外是专注于小电影与短片幕后内容的专题站，只做正片之外的创作细节——拍摄花絮、幕后故事、导演访谈、片场日记、制作特辑与创作过程，不发布任何正片资源。",
  },
  {
    q: "你们的内容是原创的吗？",
    a: "绝大多数栏目来自幕外撰稿人、跟组记者与一线创作团队的第一手记录。涉及导演访谈与制作特辑时，我们会明确标注受访对象与信息来源，并为引用内容保留原始出处。",
  },
  {
    q: "怎样才能投稿我的片场记录？",
    a: "如果你有自己的片场日记、拍摄花絮或创作复盘，欢迎通过页面底部的“投稿与合作”表单与我们联系，或直接写信到邮箱。我们欢迎真诚、具体、不灌水的幕后记录。",
  },
  {
    q: "文章里提到的“小电影”指什么？",
    a: "在幕外的语境里，“小电影”指短小精悍的影片，包含短片、微电影、独立小成本制作等，是一种对影片体量与独立气质的描述，强调小而美的创作，不含任何其他指涉。",
  },
  {
    q: "栏目内容多久更新一次？",
    a: "拍摄花絮与片场日记为周更，导演访谈与制作特辑为双周更，创作过程专栏则不定期刊发深度复盘。你可以订阅页脚邮件，第一时间收到新内容的通知。",
  },
  {
    q: "我可以转载幕外的文章吗？",
    a: "欢迎非商业用途的转载，请在显著位置注明来源“幕外”并保留原文链接。商业使用或需二次改编，请先通过页脚表单与我们取得授权。",
  },
];

export interface Testimonial {
  name: string;
  role: string;
  content: string;
}

export const TESTIMONIALS: Testimonial[] = [
  {
    name: "林一桐",
    role: "独立导演 · 《晚风电台》",
    content:
      "幕外最难得的地方，是不把幕后当噱头。他们愿意陪我把一条NG拆开讲清楚，而不是只放几张现场帅照。这样的记录对青年创作者是真的有用。",
  },
  {
    name: "许原",
    role: "影视系研究生",
    content:
      "写论文那阵子，是幕外的片场日记给了我最多灵感。那种‘原来高手也会被一条影子折磨十七遍’的诚实，比任何教科书都让人安心。",
  },
  {
    name: "苏杭",
    role: "业余短片爱好者",
    content:
      "关注幕外一年，最大的变化是开始学会‘看懂’画面背后的代价。现在每看一部片，我都会想：这场雨他们等了多久？这条戏删了几版？",
  },
  {
    name: "老麦",
    role: "录音师",
    content:
      "难得有一个栏目认真聊声音设计和现场收音，而不是只盯着画面。幕外的制作特辑，是我见过少数把幕后做‘专业’又做‘有人味’的。",
  },
];

export interface ProcessStep {
  step: string;
  title: string;
  en: string;
  desc: string;
}

export const PROCESS_STEPS: ProcessStep[] = [
  {
    step: "01",
    title: "从一个执念开始",
    en: "Idea",
    desc: "一句抱怨、一个画面或一个没头没尾的声音。创作的第一步从来不是写剧本，而是先找到一个让你放不下的执念。",
  },
  {
    step: "02",
    title: "把故事写短",
    en: "Script",
    desc: "三页梗概反推人物，再倒过来让故事自己生长。敢于删掉心爱的段落，往往比会写更接近好故事。",
  },
  {
    step: "03",
    title: "翻译成镜头",
    en: "Frame",
    desc: "九个镜头能讲完的，绝不用十个。分镜不是束缚，而是替观众提前想清楚：此刻该看脸，还是该看手。",
  },
  {
    step: "04",
    title: "让现场发生",
    en: "Shoot",
    desc: "灯光、调度、NG、临时改通告。现场是计划与意外的博弈，也是最容易长出彩蛋的地方。",
  },
  {
    step: "05",
    title: "替观众做减法",
    en: "Edit",
    desc: "剪辑房里那场心爱的戏被删掉时，真正的创作才刚刚开始。留下该留下的，忘掉舍不得的。",
  },
];

export const STATS = [
  { value: "460+", label: "条幕后记录", en: "Stories" },
  { value: "86", label: "位创作者受访", en: "Creators" },
  { value: "1200+", label: "小时片场素材", en: "Footage" },
  { value: "2019", label: "第一篇花絮", en: "Since" },
];